import React from 'react';
import Button from '../../../../components/UI/Button/Button';
import { Popconfirm } from 'antd';
import * as INTERACTION_STR from '../../../../shared/Strings/InteractionUser';
import * as BUTTON_STR from '../../../../shared/Strings/ButtonName';
import './WizardActionBar.scss';

const DO_NOTHING = () => {};
const SUMMARY_STAGE = 5;

const WizardActionBar = (props) => {
	// const stageComplete = useSelector((state) => getSafe(STATE_PATHS.JOB_CONFIG_STAGES_COMPLETE, state));
  // const stageComplete = true;

	const backButton = () => {
		return (
			props.stage !== 1 && (
				<div className="action-bar-left">
					<Button 
            btnId="back" 
            onClick={props.activeStage == 1 ? DO_NOTHING : props.onBack} 
            disabled={props.activeStage == 1} 
            className="secondary-button"
          >
						{BUTTON_STR.BACK}
					</Button>
				</div>
			)
		);
	};

	return (
		<div className="action-bar-container">
			<div className="action-bar-left">
				<Popconfirm
					data-test="pop-up-cancel"
					placement="top"
					title={INTERACTION_STR.POP_CONFIRM_ALERT}
					onConfirm={props.onCancel}
					okText={INTERACTION_STR.YES_DECISION}
					cancelText={INTERACTION_STR.NO_DECISION}
				>
					<Button btnId="cancel" className="secondary-button">
						{BUTTON_STR.CANCEL}
					</Button>
				</Popconfirm>
			</div>

			<div className="action-bar-right">
				{backButton()}
				{props.activeStage === SUMMARY_STAGE ? null : (
					<Button
						btnId="continue"
						onClick={props.activeStage != 5 ? props.onNext : DO_NOTHING}
						disabled={props.isNextDisabled}
						className={`primary-button margin-left-medium-large ${props.activeStage != 5 ? 'continue-active' : ''}`}
					>
						{BUTTON_STR.CONTINUE}
					</Button>
				)}
			</div>
		</div>
	);
};

export default React.memo(WizardActionBar);